import React from 'react';
import CharlesSchwab from './charles-schwab';
import CriticalMass from './critical-mass';
import CVSHealth from './cvs-health';
import Deloitte from './deloitte';
import Dropbox from './dropbox';
import Fedex from './fedex';
import GE from './ge';
import Google from './google';
import IBM from './ibm';
import Kroger from './kroger';
import Microsoft from './microsoft';
import MissionLane from './mission-lane';
import NASA from './nasa';
import Oscar from './oscar';
import Pfizer from './pfizer';
import Salesforce from './salesforce';
import SAP from './sap';
import Shopify from './shopify';
import UnionBank from './union-bank';
import United from './united';
import UniversityOfCambridge from './university-of-cambridge';
import UniversityOfMichigan from './university-of-michigan';
import USBank from './us-bank';
import Volkswagen from './volkswagen';

const LOGOS = [
  CharlesSchwab,
  USBank,
  United,
  Shopify,
  MissionLane,
  Fedex,
  UniversityOfMichigan,
  NASA,
  SAP,
  GE,
  Google,
  Kroger,
  UniversityOfCambridge,
  CVSHealth,
  CriticalMass,
  Salesforce,
  Deloitte,
  IBM,
  Dropbox,
  Oscar,
  Pfizer,
  Microsoft,
  Volkswagen,
  UnionBank,
];

export default function Companies() {
  return (
    <section
      className="pt-10 pb-0"
      aria-label="Shows some of the companies currently using Stark, such as: Google, Dropbox, Microsoft, United, NASA, and more"
      style={{
        maskImage:
          'linear-gradient(to right, transparent, #000 10% 90%, transparent)',
      }}>
      <div>
        <div className="flex w-max animate-company-scroll items-center gap-x-25 overflow-hidden max-mobile:animate-company-scroll-fast [&_svg]:shrink-0">
          {/* Rendered twice to make the looping scroll seamless. */}
          {[...LOGOS, ...LOGOS].map((Logo, i) => (
            <Logo key={i} />
          ))}
        </div>
      </div>
    </section>
  );
}
